import React from 'react';
import { bool, object } from 'prop-types';
import { RECENTLY_VIEWED } from '../../utils/carousels';
import SafePureComponent from '../shared/SafePureComponent';
import localStorage from '../../utils/recentlyViewedPages/localStorage';
import { RECENTLY_VIEWED_SOURCE } from './RecentlyViewedGigs/config';
import RecentlyViewedGigs from './RecentlyViewedGigs';

const RecentlyViewedGigsWrapper = ({
    isLoggedIn,
    isTouch = false,
    shouldFetchCarousel = true
}, {
    pathfinderWrapper,
    general
}) => {
    const { gigId } = general;

    const getRecentlyUrl = () => {
        const query = { exclude: gigId };

        if (!isLoggedIn) {
            query.gig_ids = localStorage.getGigIds(gigId);
        }

        return pathfinderWrapper.pathfinder(
            'gig_page_fetch_recommendations_by_type',
            { type: 'recently_viewed' },
            { query }
        );
    };

    if (!isLoggedIn && !localStorage.getGigIds(gigId).length) {
        return null;
    }

    return (
        <RecentlyViewedGigs isLoggedIn={isLoggedIn}
            url={getRecentlyUrl()}
            type={RECENTLY_VIEWED}
            carouselPosition={4}
            isTouch={isTouch}
            source={RECENTLY_VIEWED_SOURCE}
            shouldFetchCarousel={shouldFetchCarousel}/>
    );
};

RecentlyViewedGigsWrapper.propTypes = {
    isLoggedIn: bool,
    isTouch: bool,
    shouldFetchCarousel: bool
};

RecentlyViewedGigsWrapper.contextTypes = {
    general: object,
    pathfinderWrapper: object
};

export { RecentlyViewedGigsWrapper };
export default SafePureComponent(RecentlyViewedGigsWrapper);
